import React from "react";

import { Col, Container, Row } from "react-bootstrap";

import classNames from "classnames";

import { Participant, ParticipantStatus, useSearchParticipantsQuery } from "@api/graphql";
import { CustomAccordion } from "@components/accordion/CustomAccordion";

import { ParticipantTable } from "./ParticipantTable";

import styles from "./index.module.scss";

const PendingApprovalAccordionHeader = ({ data }: { data: Participant[] }) => {
  return (
    <>
      <Col sm={3}>
        <Row className={classNames(styles["accounts"], "ms-2 b3")}> Accounts pending approval</Row>
      </Col>
      <Col className="d-flex justify-content-end">
        <Row className={classNames(styles["accounts"], "b3")}>{data?.length || 0} Accounts</Row>
      </Col>
    </>
  );
};

export const PendingApproval = () => {
  const handleOnTableRowClick = () => {};

  const { data } = useSearchParticipantsQuery({
    variables: {
      filter_by: [
        {
          field: "participantStatus",
          eq: ParticipantStatus.PENDING_APPROVAL,
        },
      ],
    },
  });

  const participants = data?.searchParticipants || [];

  return (
    <Container className="p-4" fluid>
      <Row className="pb-4">
        <CustomAccordion
          accordionKey="PendingApproval"
          header={<PendingApprovalAccordionHeader data={participants} />}
          contrastOpenStyle
          defaultActiveKey="PendingApproval"
          customHeaderStyle="px-2"
        >
          <div className="p-2 pt-0 d-flex justify-content-start align-items-start align-self-stretch flex-column">
            <ParticipantTable
              onRowClick={handleOnTableRowClick}
              participants={participants}
              customTableHeaders={[
                { label: "Account ID", accessor: "participant_id", className: styles["w-col-14"] },
                { label: "Account name", accessor: "full_name", className: styles["w-col-25"] },
                { label: "Account type", accessor: "participant_types", className: styles["w-col-18"] },
                { label: "Join date", accessor: "date_created", className: styles["w-col-25"] },
                { label: "Account status", accessor: "participant_status", className: styles["w-col-18"] },
              ]}
            />
          </div>
        </CustomAccordion>
      </Row>
    </Container>
  );
};
